'use client';

import { Input, NumberInput } from '@mantine/core';
import React from 'react';

interface InputMultipleFixedLabelsProps {
  defaultValue: InputMultipleValue | undefined;
  labels: string[];
  onChange: (items: InputMultipleValue | undefined) => void;
  placeholder?: string;
  unavailable_text: string;
  className?: string;
  disabled?: boolean;
}

interface InputMultipleValue {
  [key: string]: string | number;
}

function InputMultipleFixedLabels({
  defaultValue,
  onChange,
  className,
  placeholder,
  labels,
  unavailable_text,
  disabled,
  ...props
}: InputMultipleFixedLabelsProps) {
  const [items, setItems] = React.useState<InputMultipleValue | undefined>(
    defaultValue
  );

  return (
    <div className="col-span-12 grid grid-cols-3 gap-2">
      {items != undefined &&
        labels.length > 0 &&
        labels.map((label, index) => (
          <div className="col-span-1" key={index}>
            <Input.Label className="mt-3">{label.trim()}</Input.Label>
            <NumberInput
              placeholder={placeholder}
              onBlur={(event) => {
                if (event != undefined) {
                  items[label.trim()] = event.target.value;
                  setItems(items);
                  onChange(items);
                }
              }}
              defaultValue={items[label.trim()]}
              disabled={disabled}
              min={0}
              max={100}
              suffix="%"
            />
          </div>
        ))}
      {labels.length == 0 && (
        <span className="w-full col-span-3">{unavailable_text}</span>
      )}
    </div>
  );
}

export { InputMultipleFixedLabels };
